<div class="data-health-modal-dialog__wrapper" *ngIf="dataLoaded">
  <div class="data-health-modal-dialog__top">
    <h1 mat-dialog-title class="header">
      <div class="d-flex align-items-center justify-content-between">
        <div>
          <i class="i-18 mr-10 fas fa-server"></i>
          <span class="fs-18">Data Health Status Log</span>
        </div>
        <div>
          <button trgButton class="dialog-close-btn" (click)="close()">
            <i class="fal fa-times i-12 p-relative ot-1"></i>
          </button>
        </div>
      </div>
    </h1>
    <div mat-dialog-content class="main-body">
      <table mat-table [dataSource]="dataSource" class="health-table trg-table-2">
        <ng-container matColumnDef="application">
          <th mat-header-cell *matHeaderCellDef>Application</th>
          <td
            mat-cell
            *matCellDef="let run; let i = index"
            [ngClass]="{
              'background-red': i === 0 && run.status === 1,
              'background-green': i === 0 && run.status === 0,
              'background-orange': i === 0 && run.status === 2
            }"
          >
            {{ run.application }}
          </td>
        </ng-container>

        <ng-container matColumnDef="jobName">
          <th mat-header-cell *matHeaderCellDef>Job Name</th>
          <td
            mat-cell
            *matCellDef="let run; let i = index"
            [ngClass]="{
              'background-red': i === 0 && run.status === 1,
              'background-green': i === 0 && run.status === 0,
              'background-orange': i === 0 && run.status === 2
            }"
          >
            {{ run.jobName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef style="width: 70px; text-align: center">Status</th>
          <td
            mat-cell
            *matCellDef="let run; let i = index"
            style="width: 70px; text-align: center"
            [ngClass]="{
              'background-red': i === 0 && run.status === 1,
              'background-green': i === 0 && run.status === 0,
              'background-orange': i === 0 && run.status === 2
            }"
            class="mat-cell-status"
          >
            <i class="fa fa-check-circle" *ngIf="run.status === 0" style="color: #6dd400"></i>
            <i class="fa fa-exclamation-square" *ngIf="run.status === 1" style="color: #e02020"></i>
            <i class="fa fa-exclamation-triangle" *ngIf="run.status === 2" style="color: #f29100"></i>
          </td>
        </ng-container>

        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef class="default-sort">
            <span style="text-decoration: underline">Start Time ({{ timezoneAbv }})</span>
            &nbsp;
            <i class="fa-sort-amount-down fas ml-4 mt-1"></i>
          </th>
          <td
            mat-cell
            *matCellDef="let run; let i = index"
            [ngClass]="{
              'background-red': i === 0 && run.status === 1,
              'background-green': i === 0 && run.status === 0,
              'background-orange': i === 0 && run.status === 2
            }"
          >
            {{ run.startTime | date: localisationService.CUSTOM_DATE_FORMATS.mediumDateTimeWithSeconds : { dstDate: currentTime } }}
          </td>
        </ng-container>

        <ng-container matColumnDef="endTime">
          <th mat-header-cell *matHeaderCellDef>End Time ({{ timezoneAbv }})</th>
          <td
            mat-cell
            *matCellDef="let run; let i = index"
            [ngClass]="{
              'background-red': i === 0 && run.status === 1,
              'background-green': i === 0 && run.status === 0,
              'background-orange': i === 0 && run.status === 2
            }"
          >
            {{
              run.endTime !== undefined
                ? (run.endTime | date: localisationService.CUSTOM_DATE_FORMATS.mediumDateTimeWithSeconds : { dstDate: currentTime })
                : run.endTime
            }}
          </td>
        </ng-container>

        <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef style="text-align: right">Duration (mm:ss)</th>
          <td
            mat-cell
            class="mat-cell-right"
            *matCellDef="let run; let i = index"
            [ngClass]="{
              'background-red': i === 0 && run.status === 1,
              'background-green': i === 0 && run.status === 0,
              'background-orange': i === 0 && run.status === 2
            }"
          >
            {{ run.duration }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div *ngIf="error" mat-dialog-content class="main-body">
      <p>Unable to obtain data health status information, please contact support for assistance</p>
    </div>
  </div>
  <div mat-dialog-actions align="end" class="data-health-modal-dialog__bottom">
    <button trgButton color="primary" class="min-w-100" (click)="close()">Close</button>
  </div>
</div>
<app-spinner *ngIf="!dataLoaded"></app-spinner>
